module.exports = __webpack_public_path__ + "img/sponsor.4090eb2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sponsor.png
// module id = G+WD
// module chunks = 1